var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editorId)?_c('vue-ueditor-wrap',{attrs:{"value":_vm.value,"editor-id":_vm.editorId,"config":_vm.editorConfig,"editor-dependencies":['ueditor.config.js', 'ueditor.all.js']},on:{"input":_vm.handleChange}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }